import React, { useState } from "react"
import { isMobile } from "react-device-detect"
import usePressLandingi18n from "@/i18n/usePressLandingi18n"
import PressRoomView from "@/components/PressRoomLanding/v1/PressRoomView"

const PressRoom = props => {
  const { data: authorData } = props
  const staticTexts = usePressLandingi18n({
    authorData,
  })

  const [state] = useState({
    imageLibraryLink: "",
    title: "",
    description: "",
    pressItems: [],
    productItems: [],
    rows: isMobile ? 30 : sessionStorage.getItem("rows") || 30,
    start: 0,
    ...authorData,
  })
  const { imageLibraryLink, title, description, pressItems, productItems } =
    state

  return (
    <React.Fragment>
      <PressRoomView
        i18n={staticTexts}
        imageLibraryLink={imageLibraryLink}
        title={title}
        desc={description}
        pressContact={pressItems}
        productPlacement={productItems}
      />
    </React.Fragment>
  )
}

export default PressRoom
